// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom-input[data-v-36d941dc]{font-family:Roboto,sans-serif}", ""]);
// Exports
module.exports = exports;
